import dayjs from 'dayjs';
import { SpendDatum } from './types';

export type MonthGroup = {
  key: string;
  label: string;
  total: number;
  forecast: number | null;
  firstDay: string;
  midDay: string;
};

export const groupSpendByMonth = (data: SpendDatum[]): MonthGroup[] => {
  const buckets = new Map<string, SpendDatum[]>();
  data.forEach((row) => {
    const key = dayjs(row.day).format('YYYY-MM');
    const bucket = buckets.get(key);
    if (bucket) {
      bucket.push(row);
    } else {
      buckets.set(key, [row]);
    }
  });

  const currentMonthKey = dayjs().format('YYYY-MM');

  return Array.from(buckets.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, rows]) => {
      const total = rows.reduce((sum, r) => sum + r.agent + r.ci, 0);
      const days = rows.map((r) => r.day);
      const daysInMonth = dayjs(`${key}-01`).daysInMonth();
      const daysElapsed = dayjs().date();
      const forecast =
        key === currentMonthKey && daysElapsed > 0
          ? (total / daysElapsed) * daysInMonth
          : null;
      return {
        key,
        label: dayjs(`${key}-01`).format('MMMM').toUpperCase(),
        total,
        forecast,
        firstDay: days[0],
        midDay: days[Math.floor((days.length - 1) / 2)],
      };
    });
};

export const isMultiMonth = (groups: MonthGroup[]): boolean =>
  groups.length > 1;

export const fillDailyGaps = (data: SpendDatum[]): SpendDatum[] => {
  if (data.length === 0) {
    return [];
  }
  const byDay = new Map(
    data.map((d) => [dayjs(d.day).format('YYYY-MM-DD'), d]),
  );
  const start = dayjs(data[0].day);
  const lastDay = dayjs(data[data.length - 1].day);
  const end =
    lastDay.format('YYYY-MM') === dayjs().format('YYYY-MM')
      ? lastDay.endOf('month')
      : lastDay;

  const filled: SpendDatum[] = [];
  for (let d = start; !d.isAfter(end); d = d.add(1, 'day')) {
    const key = d.format('YYYY-MM-DD');
    filled.push(byDay.get(key) ?? { day: key, agent: 0, ci: 0 });
  }
  return filled;
};
